import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ICaseStudie } from "../casestudiesModal";

export const getAllCaseStudies = createAsyncThunk(
  "CaseStudies/FindAllCaseStudies",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CaseStudies/FindAllCaseStudies`,
        {
          CaseStudiesTitle: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching CaseStudies:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createCaseStudies = createAsyncThunk(
  "CaseStudies/InsertCaseStudy",
  async (CaseStudiesData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CaseStudies/InsertCaseStudy`,
        CaseStudiesData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating CaseStudies:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateCaseStudies = createAsyncThunk(
  "CaseStudies/UpdateCaseStudy",
  async (CaseStudiesData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CaseStudies/UpdateCaseStudy`,
        CaseStudiesData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating CaseStudies:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteCaseStudies = createAsyncThunk(
  "CaseStudies/DeleteCaseStudy",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CaseStudies/DeleteCaseStudy`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting CaseStudies :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getCaseStudiesByID = createAsyncThunk(
  "CaseStudies/FindByIDCaseStudy",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CaseStudies/FindByIDCaseStudy`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        Description: result.Description,
        CaseStudieDetail: result.CaseStudieDetail,
        BannerImage: result.BannerImage,
        CardImage: result.CardImage,
        SliderImage: result.SliderImage,
        URL: result.URL,
        IsActive: result.IsActive ? 1 : 2,
      } as ICaseStudie;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching CaseStudies :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveCaseStudies = createAsyncThunk(
  "CaseStudies/FindAllActiveCaseStudies",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/CaseStudies/FindAllActiveCaseStudies`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching CaseStudies:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveCaseStudies = createAsyncThunk(
  "CaseStudies/ActiveInActiveCaseStudy",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CaseStudies/ActiveInActiveCaseStudy`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive CaseStudies :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const CaseStudiesDetailsImageUpload = createAsyncThunk(
  "CaseStudies/CaseStudyImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CaseStudies/CaseStudyImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload CaseStudies Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
